var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n_rule"},[_c('div',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,staticStyle:{"transform":"scale(1.2)","padding":"50px 0 80px"},attrs:{"src":_vm.url,"width":"100vw","page":i}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }